<template>
  <div class="footer-container ">
    <b-row class="footer-row" align-h="around">
      <b-col cols="3" style="margin-bottom: 20px;">
        <img src="@/assets/logo.png" class="logo-img ml-4" style="margin-left: 12%;" alt="">
        <div class="link-scetion">
          <p class="h6">{{ $t("phone") }}: {{$t('phoneValue')}}</p>
          <p class="h6">{{ $t("email") }}: {{$t('emailValue')}}</p>
          <p class="h6">{{ $t("website") }}:  {{$t('websiteValue')}}</p>
          <p class="h6">{{ $t("address") }}:  {{$t('addressValue')}}</p>
        </div>
        <div class="img-scetion">
          <a v-for="(item, index) in contactData" :key="index" :href="item.url" target="_blank">
            <img  :src="item.img" alt=""  >
          </a>
        </div>
      </b-col>
      <!-- <b-col cols="2"> -->
        <!-- <p class="title">{{$t('ProductsCategory')}}</p>
        <div class="content">
          <a 
            v-for="(item, index) in categoryData" 
            :href="item.router" 
            :key="index" 
            class="link-p" style="margin-right: 40px; margin-bottom: 20px;"
          >{{item.name}}</a>
        </div> -->
      <!-- </b-col> -->
      <b-col cols="3">
        <p class="title">{{$t('SENDUSAMESSAGE')}}</p>
        <div class="content">
          <b-form @submit="handleSend"  style="width:100%">
          <b-form-group
            id="fieldset-1"
            label-for="input-1"
          >
            <b-form-input id="input-1" class="input-item" v-model="fromData.name"  trim required :placeholder="$t('name')"></b-form-input>
            <b-form-input id="input-2" class="input-item" v-model="fromData.email" trim required  :placeholder="$t('email')"> </b-form-input>
            <b-form-input id="input-3" class="input-item" v-model="fromData.phone"  trim required  :placeholder="$t('phone')"></b-form-input>
            <b-form-textarea
              id="textarea"
              class="input-item"
              v-model="fromData.message"
              :placeholder="$t('message')"
              rows="3"
              max-rows="6"
              
            ></b-form-textarea>
            <b-button block class="input-item" variant="primary"  type="submit" :disabled="frombtnDisabled">{{$t('send')}}</b-button>
          </b-form-group>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { 
  List as socialApi
} from '@/api/social'
import {
  send as sendApi
} from  '@/api/send'
import { 
  Categroy as productApi,
} from '@/api/product'
import {
  mapGetters
} from 'vuex'
export default {
  data() {
    return {
      contactData:[
      ],
      categoryData:[
      ],
      fromData: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      frombtnDisabled:false 
      // state:false,
    }
  },
  computed: {
    ...mapGetters([
      'langs',
    ])
  },
  created() {
    socialApi().then(req => {
      // console.log(req)
      let data = req.data
      data.map(item => {
        // item.img = 'http://'+item.img
        
        this.contactData.push(item)
      })
      console.log(this.contactData)
    })
    productApi({
      page:1 ,
      lang: this.langs
      // rows:4
    }).then(rep => {
      let data = rep.data.data;
      data.map(item => {
        let arr = {};
        arr.router = '#/product?type='+item.id
        arr.name =  item.name
        this.categoryData.push(arr)
      })
    })
  },
  methods: {
    handleSend(event) {
      event.preventDefault()
      // console.log('111');
      this.frombtnDisabled = true
      sendApi(this.fromData).then(req => {
        console.log(req)
        var sendData = this.$t('sendSuccess')
        this.$bvModal.msgBoxOk(sendData, {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: this.$t('yes'),
          footerClass: 'p-2',
          // hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.frombtnDisabled = false
          this.onReset();
        })
        .catch(err => {
          this.frombtnDisabled = false
          // An error occurred
        })
      })
    },
    onReset(){
        // event.preventDefault()
        // Reset our form values
        this.fromData.email = ''
        this.fromData.name = ''
        this.fromData.phone = ''
        this.fromData.message = ''
        // Trick to reset/clear native browser form validation state
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/var.scss";
.footer-container{
  padding: 20px 80px;
  background: rgba(16, 16, 16, .76);
  color: $white;

  .logo-img {
    width: 110px;
    height: 110px;
    margin-bottom: 18px;
  }
  .link-scetion {
    p {
      margin-bottom: 18px;
    }
  }

  .img-scetion {
    a {
      width: 32px;
      height: 32px;
      margin: 4px;
      img {
        width: 32px;
        height: 32px;
      }
    }
      
    img:first-child {
      margin-left: 0px;
    }
  }
  .title {
    color: $primary;
    border-bottom: 2px solid $primary;
    padding-bottom: 10px;
    /* padding-right: 10px; */
    font-weight: 600;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .link-p{
      color: $white;
      display: inline-block;
    }
    .input-item{
      width: 100%;
      margin-bottom: 18px;
    }
  }
  #fieldset-1{
    width: 100%;
  }
  .btn-primary{
    color: #fff;
    font-size: 1.2rem;
    font-weight: 600;
  }
}
@media only screen and (max-width: 667px) {
  .col-7,
  .col-3,
  .col-5,
  .col-2 {
    width: 100%;
    padding: 0;
  }
  h6 {
    font-size: 0.9rem;
  }
  .tip {
    padding: 8px 40px;
  }
  .nav {
     padding: 8px 16px;
    display: flex;
    justify-content: space-between;
  }
  .cotent{
    width: 100%;
  }
  .footer-container{
    padding: 20px 30px !important;
  }
}
</style>